import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";


function Logo(p)
{
	return (<Link to={window.ROOTROOT} onClick={p.onClick} className="hampsniplink" style={{textDecoration: "none"}}>
	<div className="opacitywrapper">
	<div className="logosvg">
		<svg width="200" height="100" viewBox="0 0 60.042 25">
<defs
     id="defs2">
    <linearGradient
       id="linearGradient4583"
       x1="141.37263"
       y1="139.31529"
       x2="131.52396"
       y2="140.1055"
       gradientUnits="userSpaceOnUse"
       gradientTransform="translate(-1.6440112,126.89284)">
      <stop
         stopColor="#95b3ff"
	stopOpacity="1"
         offset="0"
         id="stop4568" />
      <stop
         stopColor="#ffb342"
	stopOpacity="1"
         offset="1"
         id="stop4570" />
    </linearGradient>

    <linearGradient
      id="linearGradient4609"
       x1="151.35475"
       y1="141.67395"
       x2="155.94258"
       y2="141.72719"
       gradientUnits="userSpaceOnUse"
       gradientTransform="translate(-11.126341,120.1006)">
      <stop
         stopColor="#359cf0"
	stopOpacity="1"
         offset="0"
         id="stop4603" />
      <stop
         stopColor="#3c08ff"
	stopOpacity="0.98809522"
         offset="1"
         id="stop4605" />
    </linearGradient>

    <linearGradient
       id="linearGradient4635"
       x1="606.8299"
       y1="974.92413"
       x2="566.73016"
       y2="970.69879"
       gradientUnits="userSpaceOnUse"
       gradientTransform="matrix(0.26458333,0,0,0.26458333,-8.7307176,11.81841)">
<stop
         id="stop4637"
         offset="0"
         stopColor="#000000"
	stopOpacity="1" />
      <stop
         id="stop4639"
         offset="1"
         stopColor="#395cff"
	stopOpacity="0.95294118" />
</linearGradient>
  </defs>
  <g
     id="layer1">
    <g
       id="g4708"
       transform="translate(-115.05995,-259.12482)">
      <path
         id="path3724-8-8-0"
         d="m 144.51626,266.55428 c -0.16305,-0.0166 -0.31765,0.1489 -0.47077,0.49505 -0.35416,0.80063 -1.01297,1.47587 -1.92288,1.97249 -0.81001,0.4421 -0.82518,0.63142 -0.0822,1.02371 0.92216,0.48687 1.71171,1.27252 1.99368,1.98386 0.0566,0.14289 0.15445,0.32019 0.21755,0.39429 0.11983,0.1407 0.3028,0.17237 0.44132,0.076 0.0447,-0.0311 0.21222,-0.29898 0.37207,-0.59531 0.40114,-0.74367 1.09285,-1.4272 1.83503,-1.81333 0.53677,-0.27928 0.59842,-0.33386 0.59842,-0.53382 0,-0.19865 -0.0606,-0.25436 -0.55811,-0.51263 -0.75083,-0.38979 -1.56242,-1.19719 -1.90376,-1.89446 -0.18636,-0.38067 -0.35734,-0.57925 -0.52038,-0.59582 z"
         style={{fillOpacity:1,strokeWidth:0.07696971}} fill="url(#linearGradient4635)"/>
      <path
         id="path3724-8-8-3"
         d="m 163.2391,275.24643 c -2.27972,-0.0352 -4.3966,1.35041 -4.96559,3.5755 -0.17701,0.69223 -0.18209,1.83698 -0.0114,2.47891 0.19628,0.73811 0.57943,1.44698 1.0728,1.98541 0.76096,0.83044 1.56076,1.27897 2.72697,1.5291 1.13732,0.24395 2.39159,0.0899 3.4804,-0.42788 1.17274,-0.55769 2.11068,-1.68193 2.47944,-2.9714 0.20173,-0.70541 0.20173,-1.943 0,-2.6484 -0.37212,-1.30125 -1.32396,-2.43989 -2.5001,-2.99104 -0.74488,-0.34906 -1.52265,-0.51845 -2.28255,-0.5302 z m -22.086,0.14677 -1.32808,0.0212 -1.32757,0.0207 -0.0202,4.58007 c -0.011,2.51884 -0.003,4.6228 0.0171,4.67569 0.0274,0.0717 0.36995,0.0961 1.34773,0.0961 h 1.31102 v -4.69689 z m -11.21533,0.004 -0.40669,0.90434 c -0.22373,0.49742 -0.71732,1.59711 -1.09709,2.44377 -0.37977,0.84667 -1.0211,2.2669 -1.42472,3.1559 -0.73703,1.62332 -1.25057,2.79559 -1.25057,2.85459 0,0.0174 0.61912,0.0315 1.37562,0.0315 h 1.37563 l 0.41393,-0.96221 0.41393,-0.96224 1.72806,0.0191 1.72754,0.0196 0.39119,0.92348 0.39171,0.92395 1.40198,0.0207 c 0.94292,0.0141 1.4025,-0.005 1.4025,-0.06 0,-0.0445 -0.30886,-0.76403 -0.68627,-1.59887 -0.3774,-0.83484 -1.28163,-2.83395 -2.00969,-4.44262 -0.72806,-1.60867 -1.3536,-3.0027 -1.3901,-3.09801 -0.0647,-0.16917 -0.0953,-0.17311 -1.21181,-0.17311 z m 22.60637,0 v 4.69532 4.69482 h 1.30845 1.30845 v -4.69482 -4.69532 h -1.30845 z m -4.99246,2.23139 c -0.48676,-0.009 -0.97835,0.12358 -1.3379,0.40102 l -0.28887,0.22273 v -0.27286 -0.27284 h -0.57723 -0.57722 v 2.42464 2.42414 h 0.61546 0.61599 l 5.1e-4,-1.36631 c 2e-4,-0.75142 0.0347,-1.48913 0.0765,-1.6397 0.24041,-0.8654 1.56838,-1.11641 2.05673,-0.3886 0.16849,0.25088 0.17518,0.32549 0.17518,1.8283 v 1.56631 h 0.62115 0.62063 l -0.0243,-1.78954 c -0.0276,-2.02358 -0.0635,-2.16913 -0.6687,-2.68719 -0.33927,-0.29038 -0.82117,-0.44106 -1.30793,-0.4501 z m -28.65975,0.003 c -0.28036,-0.003 -0.56712,0.0445 -0.83767,0.14726 -0.21687,0.0824 -0.46012,0.20934 -0.54002,0.28163 -0.13931,0.12626 -0.14521,0.12155 -0.14521,-0.1116 v -0.24289 h -0.57723 -0.57722 v 2.42776 2.42777 l 0.59686,-0.0222 0.59635,-0.0228 0.0155,-1.41076 c 0.009,-0.78653 0.0534,-1.52665 0.10129,-1.67172 0.25005,-0.75766 1.40759,-0.95766 1.86138,-0.32144 0.16887,0.2367 0.17784,0.32239 0.20154,1.84536 l 0.0248,1.59732 h 0.6103 0.6103 v -1.4831 c 0,-1.72696 0.048,-1.89785 0.62115,-2.19728 0.38426,-0.20077 0.79097,-0.19222 1.11983,0.0232 0.35987,0.23577 0.41393,0.51766 0.41393,2.15387 v 1.50326 h 0.61598 0.61547 v -1.60248 c 0,-1.80448 -0.0731,-2.21482 -0.47698,-2.67478 -0.67144,-0.76472 -1.97626,-0.86026 -2.91661,-0.21341 l -0.38396,0.26406 -0.30903,-0.26459 c -0.3243,-0.27757 -0.77347,-0.42677 -1.24075,-0.43251 z m 44.2743,0.11366 c 0.50286,-1.6e-4 0.73536,0.0374 1.00459,0.16177 0.86235,0.39846 1.31964,1.12297 1.32964,2.10476 0.003,0.31932 -0.0407,0.71951 -0.0977,0.88884 -0.24579,0.73041 -0.82637,1.2722 -1.57768,1.47227 -1.17999,0.31425 -2.26744,-0.15845 -2.83497,-1.23248 -0.24497,-0.46328 -0.24252,-1.63708 0.004,-2.10426 0.26792,-0.50747 0.60524,-0.84346 1.08056,-1.07643 0.37394,-0.18333 0.53195,-0.21431 1.0914,-0.21447 z m -32.08228,1.25317 c 0.0571,0.0571 0.67852,1.44995 0.67852,1.52083 0,0.019 -0.31521,0.0346 -0.70074,0.0346 -0.63513,0 -0.69644,-0.0123 -0.65164,-0.13435 0.24156,-0.65823 0.62596,-1.46902 0.67386,-1.42111 z"
         style={{fill:"#000000",strokeWidth:0.07696971}} />
      <path
         id="path3724"
         d="m 135.26222,261.95156 c -0.21099,0.002 -0.49764,0.15788 -0.49764,0.29197 0,0.0448 -0.12419,0.33008 -0.27595,0.63356 -0.67385,1.34757 -1.74532,2.37341 -3.1626,3.02823 -0.66749,0.30841 -0.81853,0.51469 -0.60927,0.83406 0.072,0.10984 0.18989,0.21896 0.26149,0.24236 0.71804,0.23414 1.4622,0.70517 2.16059,1.3684 0.64009,0.60785 1.0234,1.13196 1.39888,1.91099 0.16798,0.34852 0.3635,0.67677 0.4346,0.72967 0.0711,0.0529 0.18523,0.0961 0.25373,0.0961 0.21466,0 0.37303,-0.17655 0.57981,-0.64802 0.63401,-1.4456 1.63606,-2.47795 3.14606,-3.24012 l 0.7767,-0.39222 v -0.29921 -0.2992 l -0.78445,-0.39636 c -0.89052,-0.44948 -1.19125,-0.66055 -1.79886,-1.26452 -0.53164,-0.52845 -0.99253,-1.20354 -1.33635,-1.95802 -0.20657,-0.45329 -0.30631,-0.58929 -0.46199,-0.62839 -0.026,-0.007 -0.0546,-0.01 -0.0848,-0.009 z"
         style={{fillOpacity:1,strokeWidth:0.07696969}} fill="url(#linearGradient4583)" />
      <path
         id="path3724-8"
         d="m 141.92834,260.09756 c -0.10591,-0.025 -0.2117,0.09 -0.3452,0.35347 -0.21543,0.42514 -0.68872,0.88268 -1.08314,1.04748 -0.40205,0.16799 -0.35963,0.36447 0.14005,0.64647 0.44794,0.25281 0.74382,0.56171 0.97978,1.02423 0.17921,0.35126 0.32753,0.3769 0.5054,0.0863 0.38767,-0.63338 0.55574,-0.82063 0.96428,-1.0728 0.26537,-0.16379 0.44907,-0.33128 0.44907,-0.40928 0,-0.078 -0.1837,-0.24548 -0.44907,-0.40928 -0.40854,-0.25216 -0.57661,-0.43891 -0.96428,-1.07229 -0.0698,-0.11412 -0.13334,-0.17927 -0.19689,-0.1943 z"
         style={{fillOpacity:1,strokeWidth:0.07696971}} fill="url(#linearGradient4609)"/>
    </g>
  </g>		</svg></div></div></Link>);
}

export default Logo;
